import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=9edc3c8a&scoped=true"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"
import style0 from "./Password.vue?vue&type=style&index=0&id=9edc3c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edc3c8a",
  null
  
)

export default component.exports